<template>
  <div class="my_percentage_slider_layer" @mousedown.stop>
    <p :class="type === 'one_level' ? 'set_one_level': 'set_two_level'">
      <span v-if="title" v-text="title" class="title" :style="{
      width: titleWidth+ 'px'
     }"></span>
      <el-slider
        class="slider_style module"
        style="width: 120px;
        margin-right: 10px;"
        v-model="val_display"
        @change="change"
        :min="val_min"
        :max="val_max"
        :step="step"
        :disabled="disabled"
        :show-tooltip="false">
      </el-slider>
      <span class="input_display" v-if="isShow" @click="clickEvent('isShow', false)">{{val_display + symbol}}</span>
      <el-input-number
        v-else
        @blur="clickEvent('isShow', true)"
        @keyup.enter.native="clickEvent('isShow', true)"
        class="input_new"
        ref="input_new"
        v-model="val_display"
        size="small"
        :min="val_min"
        :max="val_max"
        :controls="false"></el-input-number>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'my_percentage_slider_index',
    props: {
      titleWidth: { // 组件的标题
        type: String,
        default: '40'
      },
      title: { // 组件的标题
        type: String,
        default: ''
      },
      symbol: {
        type: String,
        default: 'px'
      },
      type: { // 组件的类型  one_level 一级组件 two_level 二级组件
        type: String,
        default: 'two_level'
      },
      value: { // 输入框的值
        type: String,
        default: '0%'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      min: { // 输入框的值
        type: Number,
        default: 6.2
      },
      max: { // 输入框的值
        type: Number,
        default: 200
      },
      step: { // 步长
        type: Number,
        default: 1
      }
    },
    data () {
      return {
        val_display: this.value,// 用来显示的值
        val_max: this.max,
        val_min:this.min,
        isShow: true
      }
    },
    created () {
      this.init_data_max()
      this.init_data()
    },
    mounted () {
      let this_ = this
      window.onresize = function () {
        this_.init_data_max()
      };
    },
    watch: {
      'val_display' (val) { // 数据双向绑定
        this.setMargin(val)
      }
    },
    computed: {
      screenWidth () {
        return this.$store.state.app.screenWidth
      }
    },
    methods: {
      clickEvent (key, value) {
        this[key] = value
        if (!value) {
          this.$nextTick(() => {
            this.$refs.input_new.focus()
          })
        }
      },
      setMargin (val) {
        let percentage = '0%'
        if (val !== 0) {
          percentage = parseFloat(val / this.screenWidth * 100).toFixed(5) + '%'
        }
        this.$emit('update:value', percentage)
      },
      init_data () {
        if (parseInt(this.value) > 0) {
             this.val_display = Math.ceil(parseFloat(this.value) / 100 * this.screenWidth)
        }
      },
      init_data_max () {
        let width = this.screenWidth
        this.val_max = Math.ceil(this.max / 100 * width)
        this.val_min = Math.ceil(this.min / 100 * width)
      },
      change(val) {
        this.setMargin(val)
      }
    }
  }
</script>

<style scoped type="text/css" lang="scss">
  @import '~@/css/global-variable.scss';
  .my_percentage_slider_layer {
    .set_one_level, .set_two_level {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    /deep/ .el-slider {
      .el-slider__bar {
        background-color: $theme-primary;
      }
      .el-slider__button {
        border-color: $theme-primary;
        background-color: $theme-primary;
      }
    }
    .input_new {
      margin-left: 5px;
      width: 70px;
    }
    .input_display {
      margin-left: 5px;
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/my_percentage_slider/index.vue